import api from "./api";
import queryString from "query-string";
import qs from "qs";

export default {
  fetchOne(apiKey, event) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `events/${event}`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchAvailability(apiKey, bucket, eventIds) {
    const json = {};

    if (eventIds) {
      json.event_ids = eventIds;
    }

    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `box_office/${bucket}/availability`,
          json,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchAllForBucket(apiKey, bucket, includeScanCounts, excludeOlderEvents) {
    let queryString = {};
    queryString.include_scan_counts = includeScanCounts ? true : undefined;
    queryString.exclude_older_events = excludeOlderEvents ? true : undefined;

    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/${bucket}/events`,
          api_key: apiKey,
          qs: Object.keys(queryString).length > 0 ? queryString : undefined
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.events);
        }
      );
    });
  },

  fetchAllForVenueInBucket(apiKey, venue, bucket, includeScanCounts) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/${bucket}/events`,
          api_key: apiKey,
          qs: includeScanCounts
            ? {
                include_scan_counts: true,
                conditions: JSON.stringify({
                  venue: venue
                })
              }
            : undefined
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.events);
        }
      );
    });
  },

  fetchAllByTag(apiKey, eventBucket, tag, params = {}) {
    let newParams = { ...params }

    if (params.sorted && params.sorted.length !== 0) {
      newParams = { ...newParams, sortedId: params.sorted[0].id, sortedIsDesc: params.sorted[0].desc }
    }

    return new Promise((resolve, reject) => {
      api.request({
        method: "GET",
        endpoint: `/event_buckets/${eventBucket}/tags/${tag}/events?${qs.stringify(newParams)}`,
        api_key: apiKey
      }, function (err, response) {
        if (err) {
          return reject(err);
        }
        resolve(response);
      })
    })
  },

  edit(apiKey, event, values, applyRecurring) {
    console.log(applyRecurring);
    if (values.rules) {
      values.rules = JSON.stringify(values.rules);
    }
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `events/${event}${
            applyRecurring
              ? "?" + queryString.stringify({ apply_recurring: applyRecurring })
              : ""
          }`,
          json: values,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            err._event = event;
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  editImage(apiKey, event, field, file) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `events/${event}`,
          fileField: field,
          file: file,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            err._event = event;
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  delete(apiKey, event, applyRecurring) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "DELETE",
          endpoint: `events/${event}${
            applyRecurring
              ? "?" + queryString.stringify({ apply_recurring: applyRecurring })
              : ""
          }`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  duplicate(apiKey, event) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `events/${event}/duplicate`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            err._event = event;
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  create(apiKey, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `events`,
          json: values,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/EventUtil.js